import React from 'react';
import classNames from "classnames";
import styles from './XProgressBar.module.scss';
import { ETheme } from '../../../types/enums/ETheme';
import { XComponent } from '../../commons/XComponent';
import { IProgressBarProps } from './IProgressBarProps';
import { IProgressBarState } from './IProgressBarState';

export class XProgressBar extends XComponent<HTMLDivElement, IProgressBarProps, IProgressBarState> {
    static defaultProps = {
        ...XComponent.defaultProps,
        theme: ETheme.Blue,
        value: 100,
        maximum: 100
    }
    reference: React.RefObject<HTMLDivElement>;

    public constructor(props: IProgressBarProps) {
        super(props);
        this.state = {
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme,
            value:
                this.props.infinity? 30 :
                this.props.value === undefined
                ? 100
                : this.props.value,
            maximum: this.props.maximum === undefined
                ? 100
                : this.props.maximum
            
        };
        this.onClick = this.onClick.bind(this);
        this.setValue = this.setValue.bind(this);
        this.reference = React.createRef();
    }
    
    componentDidMount(): void{
        this.setValue(this.state.value);
        //this.reference.current?.setAttribute('style', '--value: ' + this.state.value);
    }
    componentWillUnmount(): void{}
    componentDidUpdate(prevProps: IProgressBarProps, prevState: IProgressBarState) {
        this.updateText();
    }

    onClick(): void {this.props.onClick?.(this);};

    setValue(value: number) {
        // if(this.props.infinity)
        //     return;
        this.setState({value: value});
        this.updateText();
    }
    updateText() {        
        this.reference.current?.setAttribute('style', '--value: ' + Math.round(this.state.value/this.state.maximum*100) + '%');
    }


    render(): React.ReactNode {
        let text: string | undefined = undefined;

        if(!this.props.infinity)
            text = this.props.isPercent
            ? Math.round(this.state.value/this.state.maximum*100) + '%'
            : this.state.value + '/' + this.state.maximum;

        if(this.props.formated)
            text = text
            ? this.props.formated.replace('{0}', text)
            : this.props.formated;

        return (
            <div ref={this.reference} className={classNames(styles.XProgressBar)} data-theme={this.state.theme} onClick={this.onClick} data-infinity={this.props.infinity}>
                {text}
            </div>
        );
    }
}
